import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getDisplayTextLabelText } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useContext, useRef } from 'react';
import { useOccContext } from '../../../../../context/occ/hooks/use-occ-context';
import { ExpandContentIndicator } from '../../../../expand-content-indicator/expand-content-indicator';
import { DropdownContextInstance } from '../types/context';
import { getIdForDropdownButton } from '../utils';
import { DropdownSearchInput } from './search-input';
const defaultIconName = 'triangle-down';
const defaultClearIconName = 'cross';
const b = bemClassBuilder('v-dropdown-button');
export const DropdownButton = observer(props => {
    var _a;
    const { assets: occAssets, config: { form: formConfig } } = useOccContext();
    const buttonRef = useRef(null);
    const searchInputRef = useRef(null);
    const context = useContext(DropdownContextInstance);
    const { dropdownId, selectedOption, optionPreviewTemplate: OptionDetails, isDropdownExpanded, showSearch, disabled, loading } = context;
    const { label, placeholder, helpTextId, onClick, onIconClick, style, hasLabelElement, isExpanded } = props;
    const showClearButton = showSearch && !!((_a = context.searchTerm) === null || _a === void 0 ? void 0 : _a.length);
    const focusButton = () => { var _a; return (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus(); };
    const renderIconButton = () => {
        var _a;
        const loadingIconName = props.loadingIconName || occAssets.loadingIconName;
        const dropdownIconName = showClearButton ? defaultClearIconName : (_a = props.iconName) !== null && _a !== void 0 ? _a : defaultIconName;
        const iconName = loading ? loadingIconName : dropdownIconName;
        const iconButtonType = loading ? 'loading' : showClearButton ? 'clear' : undefined;
        return (_jsx("div", { className: b.element('icon-button', { showSearch, type: iconButtonType }), onClick: handleIconButtonClick, children: _jsx(ExpandContentIndicator, { isExpanded: isExpanded, iconName: iconName, className: b.element('icon', { loading }) }) }));
    };
    const handleIconButtonClick = (_e) => {
        var _a;
        if (showClearButton) {
            (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.setSearchTerm('');
        }
        else {
            if (loading)
                return;
            onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick();
        }
    };
    const buttonId = getIdForDropdownButton(dropdownId);
    const buttonLabel = selectedOption ? selectedOption.text : placeholder;
    const ariaAttributes = {
        'aria-haspopup': 'listbox',
        'aria-expanded': isDropdownExpanded || undefined,
        'aria-disabled': disabled || undefined,
        'aria-describedby': helpTextId,
        'aria-label': label && hasLabelElement ? `${getDisplayTextLabelText(label)} ${buttonLabel}` : buttonLabel,
        'aria-autocomplete': showSearch ? 'list' : 'none'
    };
    const className = b.block({
        placeholder: !selectedOption && !!placeholder,
        style,
        loading: !!loading,
        showSearch
    });
    return (_jsx("button", Object.assign({ ref: buttonRef, className: className, id: buttonId, onClick: onClick, disabled: disabled || loading, type: "button" }, ariaAttributes, { children: _jsxs("div", { className: b.element('wrapper'), children: [showSearch ? (_jsx(DropdownSearchInput, { ref: searchInputRef, className: b.element('search-input'), placeholder: placeholder, enableClearIcon: false, ariaAttributes: ariaAttributes, onComponentWillUnmount: focusButton })) : (_jsx("span", { className: b.element('placeholder'), children: selectedOption
                        ? OptionDetails(Object.assign({}, selectedOption))
                        : isDropdownExpanded || !hasLabelElement || !formConfig.enableFloatingInputLabels
                            ? placeholder
                            : undefined })), renderIconButton()] }) })));
});
DropdownButton.displayName = 'DropdownButton';
//# sourceMappingURL=button.js.map